import { createSlice } from '@reduxjs/toolkit';

import type { RegistroIntimacaoSentencaState } from '../../types/registroIntimacaoSentenca';
import { registrarIntimacaoSentencaParte } from './actions';

const initialState: RegistroIntimacaoSentencaState = {
  registrando: false,
  erro: null,
};

const registroIntimacaoSentencaSlice = createSlice({
  name: 'secretariaArbitralRegistroIntimacaoSentenca',
  initialState,
  reducers: {
    limparErroRegistroIntimacaoSentenca(state) {
      state.erro = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(registrarIntimacaoSentencaParte.pending, (state) => {
        state.registrando = true;
        state.erro = null;
      })
      .addCase(registrarIntimacaoSentencaParte.fulfilled, (state) => {
        state.registrando = false;
      })
      .addCase(registrarIntimacaoSentencaParte.rejected, (state, action) => {
        state.registrando = false;
        state.erro =
          action.payload ?? action.error.message ?? 'Erro ao registrar a intimação da sentença';
      });
  },
});

export const { limparErroRegistroIntimacaoSentenca } = registroIntimacaoSentencaSlice.actions;
export const secretariaArbitralRegistroIntimacaoSentencaReducer =
  registroIntimacaoSentencaSlice.reducer;
